var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    {
      staticClass: "pb-3",
      attrs: {
        height: 340,
        width: 2250,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb",
      },
    },
    [
      _c("rect", {
        attrs: { height: "60", width: "2250", y: "0", x: "0", rx: "5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { height: "60", width: "2250", y: "70", x: "0", rx: "5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { height: "60", width: "2250", y: "140", x: "0", rx: "5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { height: "60", width: "2250", y: "210", x: "0", rx: "5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { height: "60", width: "2250", y: "280", x: "0", rx: "5" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }